/**
 * Utility functions for formatting data
 */

/**
 * Format a number with thousand separators
 * @param {number} num - The number to format
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} Formatted number with thousand separators
 */
export const formatNumber = (num, locale = 'en-US') => {
  if (num === null || num === undefined || isNaN(num)) return '';
  
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }).format(num);
};

/**
 * Format a price with currency symbol
 * @param {number} price - The price to format
 * @param {string} currency - The currency code (default: 'USD')
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} Formatted price with currency symbol
 */
export const formatPrice = (price, currency = 'USD', locale = 'en-US') => {
  if (price === null || price === undefined || isNaN(price)) return '';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }).format(price);
};

/**
 * Format a date to localized string
 * @param {Date|string} date - The date to format
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @param {Object} options - Date formatting options
 * @returns {string} Formatted date string
 */
export const formatDate = (date, locale = 'en-US', options = {
  year: 'numeric',
  month: 'short',
  day: 'numeric'
}) => {
  if (!date) return '';
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString(locale, options);
}; 